import { useState } from 'react';
import ArrowDownYel from '../images/arrow-down-yel.svg';

interface EngineeringFeatureItem {
    id: string;
    name: string;
}

interface EngineeringFeatureGroup {
    name: string;
    features: EngineeringFeatureItem[];
}

const engineeringFeatures: EngineeringFeatureGroup[] = [
    {
        name: 'Отрасль',
        features: [
            { id: 'ENG0001', name: 'Жилищно-коммунальное хозяйство' },
            { id: 'ENG0002', name: 'Нефтегазовая отрасль' },
            { id: 'ENG0003', name: 'Машиностроение' },
            { id: 'ENG0004', name: 'Пищевая промышленность' },
            { id: 'ENG0005', name: 'Энергетика' },
            { id: 'ENG0006', name: 'Металлургия и горнодобывающая промышленность' },
            { id: 'ENG0007', name: 'Химическая промышленность' },
            { id: 'ENG0008', name: 'Легкая промышленность' },
            { id: 'ENG0009', name: 'Сельское хозяйство' },
            { id: 'ENG0010', name: 'Строительство' },
            { id: 'ENG0011', name: 'Транспорт' },
        ],
    },
    {
        name: 'Специализация',
        features: [
            { id: 'ENG1001', name: 'Отопление, вентиляция и кондиционирование' },
            { id: 'ENG1002', name: 'Водоподготовка, водоснабжение и водоотведение' },
            { id: 'ENG1003', name: 'Электрораспределение и освещение' },
            { id: 'ENG1004', name: 'Автоматизация технологических процессов' },
            { id: 'ENG1005', name: 'Теплогенерация, парогенерация и распределение' },
            { id: 'ENG1006', name: 'Подъемно-транспортное оборудование' },
            { id: 'ENG1007', name: 'Насосное оборудование' },
            { id: 'ENG1008', name: 'Системы управления зданием' },
            { id: 'ENG1009', name: 'Конвейеры и упаковочное оборудование' },
            { id: 'ENG1010', name: 'Печи и системы нагрева' },
        ],
    },
];

interface EngineeringFilterSectionProps {
    selectedById: Record<string, boolean>;
    onToggleFeature: (featureId: string) => void;
}

export default function EngineeringFilterSection({
    selectedById,
    onToggleFeature,
}: EngineeringFilterSectionProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                className="engineering-filter-toggle"
                onClick={() => setIsOpen((value) => !value)}
                type="button"
            >
                <img
                    alt="arrow-down"
                    className={
                        'engineering-filter-toggle__icon' +
                        (isOpen ? ' engineering-filter-toggle__icon--opened' : '')
                    }
                    src={ArrowDownYel}
                />
                <span className="feature-filter-block__title destributors-filter-block__title">
                    Авторизованные инжиниринговые партнеры
                </span>
            </button>
            {isOpen && (
                <div className="engineering-filter-list">
                    {engineeringFeatures.map((group) => (
                        <div className="engineering-filter-list__group" key={group.name}>
                            <div className="engineering-filter-list__group-title">{group.name}</div>
                            <ul className="engineering-filter-list__items">
                                {group.features.map((feature) => (
                                    <li className="engineering-filter-list__item" key={feature.id}>
                                        <label className="engineering-filter-list__label">
                                            <input
                                                checked={!!selectedById[feature.id]}
                                                className="engineering-filter-list__checkbox"
                                                onChange={() => onToggleFeature(feature.id)}
                                                type="checkbox"
                                            />
                                            <span>{feature.name}</span>
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
